import type { ApiRoute, NoBody, NoQueryParams } from "../../../api"
import type { CustomerFeedbackView } from "./CustomerFeedbackView"

export interface GetCustomerFeedbackViewPathParams {
	inventoryId: string
}

export const getCustomerFeedbackViewRoute: ApiRoute<
	GetCustomerFeedbackViewPathParams,
	NoQueryParams,
	NoBody,
	CustomerFeedbackView
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/customer-feedback`,
	method: "get",
	path: "/vehicles/:inventoryId/customer-feedback",
}
